import { Component, Element, Host, Prop, h } from '@stencil/core';

import EventBus from '../../../services/service.eventBus';
import { DynamicEntryStartButton } from '../DynamicEntryStartButton';

@Component({
  tag: 'dynamic-entry-duplicate-offer-modal',
  styleUrl: 'dynamic-entry-duplicate-offer-modal.css',
})
export class DynamicEntryDuplicateOfferModal {
  @Element() el: HTMLElement;
  @Prop() offerId: string = '';
  @Prop() userId: string = '';

  componentDidLoad() {
    this.showModal();
  }

  showModal() {
    this.getModal()?.open();
  }

  getModal() {
    return this.el.querySelector('ico-modal#duplicate-offer-modal') as HTMLIcoModalElement;
  }

  onOpenOfferClick() {
    EventBus.publish('DuplicateOfferModalOpenOffer', { userId: this.userId, offerId: this.offerId });
    this.closeModal();
  }

  closeModal() {
    this.getModal()?.close();
    this.emitCloseEvent();
  }

  emitCloseEvent() {
    EventBus.publish('DuplicateOfferModalClosed', null);
  }

  render() {
    return (
      <Host>
        <ico-modal dataTestId="duplicate-offer" id="duplicate-offer-modal" shouldCloseOnBackdrop={false}>
          <h1 class="dynamic-entry-duplicate-modal-heading font-semibold text-2xl mt-3 max-w-44 md:w-96 md:max-w-none">Matching Offer Found</h1>
          <div class="dynamic-entry-duplicate-modal-text">Please use the existing offer.</div>
          <div class="flex justify-between mt-4 md:mt-8 gap-2 md:gap-6 duplicate-modal-button-group">
            <DynamicEntryStartButton data-testid="bi-btn-cancel" class="w-full" label="Cancel" whenClicked={() => this.closeModal()} color="tertiary" />
            <DynamicEntryStartButton data-testid="bi-btn-open-offer" class="w-full" label="Open Offer" whenClicked={() => this.onOpenOfferClick()} />
          </div>
        </ico-modal>
      </Host>
    );
  }
}
